import React from 'react';
import './Common.css';

/**
 * Компонент для отображения успешных сообщений
 */
const SuccessMessage = ({ message }) => {
  if (!message) return null;

  return <div className="success-message">{message}</div>;
};

export default SuccessMessage;
